<template>
  <div>
    <!-- Filter information -->
    <div class="pg_sec" v-if="!isShowLess">
      <div class="floating_filter_container" v-if="(isEMSIFeatureEnabled || isBGTFeatureEnabled ) && ((isWidget && showCityStateFilterOnWidget) || !isWidget)">
        <b-btn @click="showFloatingFilterSection">
          <span class="ic-filter"></span>
        </b-btn>
      </div>
      <div class="row filters_section" style="margin-left: 10px; margin-right: 10px;">
        <div class="col-12 col-lg-12 col-md-12 col-sm-12 hd ace_sec_hd filter_hd" aria-label="Filter by State or City" v-if="(isEMSIFeatureEnabled || isBGTFeatureEnabled) && ((isWidget && showCityStateFilterOnWidget) || !isWidget)">
          <!--<span class="ic icon-filter"></span>-->
          <h2>Filter by State or City</h2>
          <span class="hd_bdr"></span>
          <div class="close_floating_filter">
            <b-btn class="btn_close" @click="hideFloatingFilterSection">
              <span class="ic-close"></span>
            </b-btn>
          </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 filter_select_section" v-if="(isEMSIFeatureEnabled || isBGTFeatureEnabled ) && ((isWidget && showCityStateFilterOnWidget) || !isWidget)">
          <b-input-group class="row frm_sec">
            <div class="col-11 frm_fld_col">
              <div class="row">
                <div v-if="formattedGeoIdMap && formattedGeoIdMap.stateGeoIds" class="frm_fld state">
                  <label for="state">Select State</label>
                  <v-select class="select-field" :disabled="disableSelectState" v-model='selectedState'
                    :options='formattedGeoIdMap.stateGeoIds' placeholder="Select or Search for a State" :class="!selectedState ? 'no_value_selected' : ''"></v-select>
                  <span class="fld_info">
                  <span v-if="disableSelectState">To select state clear the city selection first</span>
                  </span>
                </div>
                <div class="frm_label">
                  <label>OR</label>
                </div>
                <div v-if="formattedGeoIdMap && formattedGeoIdMap.msaGeoIds" class="frm_fld city">
                  <label for="city" title="city">Select City</label>
                  <v-select class="select-field" :disabled="disableSelectMetroArea" v-model='selectedMetroArea'
                    :options='formattedGeoIdMap.msaGeoIds' placeholder="Select or Search for a City" :class="!selectedMetroArea ? 'no_value_selected' : ''"></v-select>
                  <span class="fld_info">
                  <span v-if="disableSelectMetroArea">To select city clear the state selection first</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-1 frm_btn_col">
              <b-btn @click="careerSearchClicked" aria-label="go">Go</b-btn>
            </div>
          </b-input-group>
        </div>
      </div>
      <div class="row tabs_separator" :class="(isEMSIFeatureEnabled || isBGTFeatureEnabled) ? '' : 'no_tabs'">
        <div class="col-12 tabs_separator_inner"></div>
        <div class="col-12 tabs_separator_spacer"></div>
      </div>
      <div class="row career_prospect_tabs_container">
        <div class="col-12 career_prospect_detail">
          <template  v-if="!(isEMSIFeatureEnabled || isBGTFeatureEnabled)">
            <!-- Job Posting -->
            <div class="row pg_sec sec_job_posting" :class="selectedMetroArea ? 'city_data_selected' : ''">
              <div class="col-12 hd ace_sec_hd job_posting_sec_hd" aria-label="Job Posting Overview">
                <h2>Job Posting Overview</h2>
                <span class="hd_bdr"></span>
              </div>
              <div class="data_info_sec">
                <span v-if="selectedCounty"> {{ selectedCounty.label }} </span>
                <span v-else-if="selectedState"> {{ selectedState.label }} </span>
                <span v-else-if="selectedMetroArea"> {{selectedMetroArea.label}} </span>
                <span v-else> US National </span>
                <span> Data </span>
                <span> for {{majorTitle}} </span>
              </div>
              <div class="col-12">
                <div class="row sec_content">
                  <div v-if="formattedCareer && formattedCareer.aggregatedMedianHourlyEarning" class="col-4 gph_sec ace_sec" :aria-label="'Median Income $ ' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)">
                    <div class="gph_chart">
                      <doughnut-chart :chart-data="medianIncomePieData"></doughnut-chart>
                      <div class="donut_chart_val_container">
                        <div class="donut_chart_val">
                          <div class="gph_val">
                            $<span v-html="addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="gph_title">
                      <span class="main_title">Median Income</span>
                    </div>
                  </div>
                  <div v-if="formattedCareer && formattedCareer.aggregatedGrowthPercentage && !selectedMetroArea" class="col-4 gph_sec ace_sec" :aria-label="'Estimated Job Growth 2023-2033 ' + formattedCareer.aggregatedGrowthPercentage + '%'">
                    <div class="gph_chart gph_pie_chart">
                      <div class="chart_layer"></div>
                      <doughnut-chart :chart-data="growthPieData" id="gauge" :options="growthPieOptions" @afterComplete="callDrawNeedle"></doughnut-chart>
                      <div class="gph_val pie_chart_val">
                        <span v-html="(Math.round(formattedCareer.aggregatedGrowthPercentage * 100) / 100).toFixed(1)"></span><span>%</span>
                      </div>
                      <div class="gph_title pie_gph_title">
                        <span class="main_title">Estimated Job Growth</span> <br/> <span>2023-2033</span>
                      </div>
                    </div>
                    <div class="gph_title gph_lg_sec">
                      <div class="lg_sec_blc">
                        <div class="lg_blc lt_0"></div>
                        <div class="lg_txt"> &lt; 0%</div>
                      </div>
                      <div class="lg_sec_blc">
                        <div class="lg_blc bt_0-15"></div>
                        <div class="lg_txt"> 0-15%</div>
                      </div>
                      <div class="lg_sec_blc">
                        <div class="lg_blc gt_15"></div>
                        <div class="lg_txt"> &gt; 15%</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="formattedCareer && formattedCareer.aggregatedLastYearJob" class="col-4 gph_sec ace_sec" :aria-label="'job postings in the last 12 months ' + addCommaInNumber(formattedCareer.aggregatedLastYearJob)">
                    <div class="gph_chart">
                      <doughnut-chart :chart-data="jobPostingsPieData"></doughnut-chart>
                      <div class="donut_chart_val_container">
                        <div class="donut_chart_val">
                          <div class="gph_val">
                            <span v-html="formatNumericVal(formattedCareer.aggregatedLastYearJob)"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="gph_title">
                      <span class="main_title">Job Postings</span> <br/> <span>in the Last 12 Months</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Job Posting -->

            <!-- Careers -->
            <div class="row pg_sec sec_career" v-if="!isShowLess">
              <div class="col-12 hd ace_sec" aria-label="Career Options" style="margin-bottom: 0px;">
                <!-- custom career chart -->
                <div class="row pg_sec career_chart_container">
                  <div class="col-12 hd ace_sec_hd" aria-label="Carrers">
                    <h2 aria-label="Careers">Top Occupations by Median Income</h2>
                    <span class="hd_bdr"></span>
                    <template v-if="(showEducationLevelEnabled && !isWidget) || (isWidget && showEducationLevelOnWidgetEnabled)">
                      <template v-if="showAllOccupations">
                        <b-link @click="toggleShowOccupations()">Show Careers At Your Program Level</b-link>
                      </template>
                      <template v-if="!showAllOccupations">
                        <b-link @click="toggleShowOccupations()">Show All Careers</b-link>
                      </template>
                    </template>
                  </div>
                  <div class="col-12 ace_sec" aria-label="Careers Chart">
                    <div class="avg_val ace_sec_txt" :aria-label="'Median Income $ ' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)">
                      <span class="avg_val_txt">
                      Median Income - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></span>
                      </span>
                    </div>
                    <div class="avg_val_connecter"></div>
                    <div class="bar_chart_container bar_label_inside">
                      <template v-for="(formattedCareer, index) in targetOccupationItems">
                        <div class="row bar_row ace_sec">
                          <div class="col-12">
                            <!--
                              <div id="careersDetailsToolTip" class="chart_tooltip_popover"></div>
                              <b-popover :target="'popoverCareersDetails_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="careersDetailsToolTip">
                                <div class="tooltip_row">
                                   <div class="val">{{ formattedCareer.name }}</div>
                                </div>
                                <div class="tooltip_row">
                                  <div class="val"><span v-html="'$' + addCommaInNumber(formattedCareer.medianHourlyEarning)"></span></div>
                                </div>
                              </b-popover>
                              -->
                              <div class="bar_container jobs" @click="navigateToCareer(formattedCareer)">
                                <div class="bar_content">
                                  <div class="row">
                                    <div class="col-8 col-lg-8 col-md-8 col-sm-8 bar_label">{{ formattedCareer.Occupation }} </div>
                                    <div class="col-4 col-lg-4 col-md-4 col-sm-4 bar_val"><span v-html="'$' + addCommaInNumber(formattedCareer['Median Earnings'])"></span></div>
                                  </div>
                                  <div class="row edu_label" v-if="(showEducationLevelEnabled && !isWidget) || (isWidget && showEducationLevelOnWidgetEnabled)">
                                    <div class="col-12 tags_row">
                                      <template v-for="edu in formattedCareer['Education'] ">
                                        <div class="tag ace_sec_txt" v-if="edu.score > 0">
                                          <span class="edu_level" :class="'edu_' + edu.level.charAt(0)" :title="edu.level">
                                          {{edu.level.charAt(0)}}
                                          </span>
                                          <span class="edu_score"><span v-html="formatNumericVal(edu.score)"></span>%</span>
                                        </div>
                                      </template>
                                    </div>
                                  </div>
                                </div>
                                <div class="bar" v-bind:style="{width:setIncomeBarWidth(formattedCareer['Median Earnings'])}"></div>
                              </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>

                <!-- custom career chart -->
                <!-- old code - need to remove after testing :: Neeraj 06 July 2020 [line 188 to 215] -->
                <!--
                  <div class="career_chart_container">
                    <h2 class="ace_sec_txt" aria-label="Careers">Careers</h2>
                    <div class="custom_dot_gph_container">

                        <div class="career_chart">
                          <scatter-chart :data="incomeScatterData" :height="50"></scatter-chart>
                        </div>

                        <div class="line"></div>
                        <div class="avg_val_connecter"></div>

                        <template v-for="formattedCareer in formattedCareers">
                          <div class="dot" v-bind:style="{left:setDotMargin(formattedCareer.medianHourlyEarning)}"
                            :title="formattedCareer.name + ' | $' + formattedCareer.medianHourlyEarning">
                          </div>
                        </template>

                    </div>

                    <div class="avg_val ace_sec_txt" :aria-label="'Median Income $ ' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)">
                      Median Income - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></span>
                    </div>
                  </div>

                  -->
                <!-- old code - need to remove after testing :: Neeraj 06 July 2020 [line 188 to 215] -->
              </div>
            </div>
            <!-- End Careers -->
          </template>
          <div class="row tab_border"></div>
          <b-card no-body v-if="isEMSIFeatureEnabled || isBGTFeatureEnabled">
            <div class="tabs tabs_panel">
              <div class="card-header crd_hd">
                <ul class="nav nav-tabs card-header-tabs">
                  <template v-if="isWidget && !unlockCompaniesSkillsOnWidget">
                    <li class="nav-item">
                      <b-link class="nav-link active" id="tab_Jobs" @click="showTabContent('tab_Jobs', 'tabPan_Jobs')">
                        <span class="btn_txt">Jobs</span>
                      </b-link>
                    </li>
                    <li class="nav-item">
                      <b-link class="nav-link" @click="showNewFormPopup('showAtTop')">
                        <span class="btn_txt">Companies</span>
                        <span class="ic-lock"></span>
                      </b-link>
                    </li>
                    <li class="nav-item">
                      <b-link class="nav-link" @click="showNewFormPopup('showAtTop')">
                        <span class="btn_txt">Skills</span>
                        <span class="ic-lock"></span>
                      </b-link>
                    </li>
                  </template>
                  <template v-else>
                    <li class="nav-item">
                      <b-link class="nav-link active" id="tab_Jobs" @click="showTabContent('tab_Jobs', 'tabPan_Jobs')">
                        <span class="btn_txt">Jobs</span>
                      </b-link>
                    </li>
                    <li class="nav-item">
                      <b-link class="nav-link" id="tab_Companies" @click="showTabContent('tab_Companies', 'tabPan_Companies')">
                        <span class="btn_txt">Companies</span>
                      </b-link>
                    </li>
                    <li class="nav-item">
                      <b-link class="nav-link" id="tab_Skills" @click="showTabContent('tab_Skills', 'tabPan_Skills')">
                        <span class="btn_txt">Skills</span>
                      </b-link>
                    </li>
                  </template>
                </ul>
                <!-- .card-header-tabs -->
              </div>
              <!-- .card-header -->
            </div>
            <!-- .tabs -->
            <div class="tab_content_section">
              <div class="tab_content_container">
                <div class="tab_content active" id="tabPan_Jobs">
                  <div class="tab_info" v-if="isWidget && !unlockCompaniesSkillsOnWidget">
                    Click on companies or skills to unlock more details
                  </div>
                  <!-- Job Posting -->
                  <div class="row pg_sec sec_job_posting" :class="selectedMetroArea ? 'city_data_selected' : ''">
                    <div class="col-12 hd ace_sec_hd job_posting_sec_hd" aria-label="Job Posting Overview">
                      <h2>Job Posting Overview</h2>
                      <span class="hd_bdr"></span>
                    </div>
                    <div class="data_info_sec">
                      <span> {{selectedDataInfo}} Data </span>
                    </div>
                    <div class="col-12">
                      <div class="row sec_content">
                        <div v-if="formattedCareer && formattedCareer.aggregatedMedianHourlyEarning" class="col-4 gph_sec ace_sec gph_median_income" :aria-label="'Median Income $ ' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)">
                          <div class="gph_chart">
                            <doughnut-chart :chart-data="medianIncomePieData"></doughnut-chart>
                            <div class="donut_chart_val_container">
                              <div class="donut_chart_val">
                                <div class="gph_val">
                                  $<span v-html="addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="gph_title">
                            <span class="main_title">Median Income</span>
                          </div>
                        </div>
                        <div v-if="formattedCareer && formattedCareer.aggregatedGrowthPercentage && !selectedMetroArea" class="col-4 gph_sec ace_sec" :aria-label="'Estimated Job Growth 2023-2033 ' + formattedCareer.aggregatedGrowthPercentage + '%'">
                          <div class="gph_chart gph_pie_chart">
                            <div class="chart_layer"></div>
                            <doughnut-chart :chart-data="growthPieData" id="gauge" :options="growthPieOptions" @afterComplete="callDrawNeedle"></doughnut-chart>
                            <div class="gph_val pie_chart_val">
                              <span v-html="(Math.round(formattedCareer.aggregatedGrowthPercentage * 100) / 100).toFixed(1)"></span><span>%</span>
                            </div>
                            <div class="gph_title pie_gph_title">
                              <span class="main_title">Estimated Job Growth</span> <br/> <span>2023-2033</span>
                            </div>
                          </div>
                          <div class="gph_title gph_lg_sec">
                            <div class="lg_sec_blc">
                              <div class="lg_blc lt_0"></div>
                              <div class="lg_txt"> &lt; 0%</div>
                            </div>
                            <div class="lg_sec_blc">
                              <div class="lg_blc bt_0-15"></div>
                              <div class="lg_txt"> 0-15%</div>
                            </div>
                            <div class="lg_sec_blc">
                              <div class="lg_blc gt_15"></div>
                              <div class="lg_txt"> &gt; 15%</div>
                            </div>
                          </div>
                        </div>
                        <div v-if="formattedCareer && formattedCareer.aggregatedLastYearJob" class="col-4 gph_sec ace_sec" :aria-label="'job postings in the last 12 months ' + addCommaInNumber(formattedCareer.aggregatedLastYearJob)">
                          <div class="gph_chart">
                            <doughnut-chart :chart-data="jobPostingsPieData"></doughnut-chart>
                            <div class="donut_chart_val_container">
                              <div class="donut_chart_val">
                                <div class="gph_val">
                                  <span v-html="formatNumericVal(formattedCareer.aggregatedLastYearJob)"></span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="gph_title">
                            <span class="main_title">Job Postings</span> <br/> <span>in the Last 12 Months</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Job Posting -->
                  <!-- Careers -->
                  <div class="row pg_sec sec_career" v-if="!isShowLess">
                    <div class="col-12 hd ace_sec" aria-label="Career Options" style="margin-bottom: 0px;">
                      <!-- custom career chart -->
                      <div class="row pg_sec career_chart_container">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-12 hd ace_sec_hd" aria-label="Carrers">
                              <h2 aria-label="Careers">Top Occupations by Median Income</h2>
                              <span class="hd_bdr"></span>
                            </div>
                          </div>
                          <template v-if="(showEducationLevelEnabled && !isWidget) || (isWidget && showEducationLevelOnWidgetEnabled)">
                            <div class="row" style="margin-bottom: 10px;">
                              <div class="col-10 ace_sec_hd lnk_sec">
                                <template v-if="showAllOccupations">
                                  <b-link @click="toggleShowOccupations()">Show Careers At Your Program Level</b-link>
                                </template>
                                <template v-if="!showAllOccupations">
                                  <b-link @click="toggleShowOccupations()">Show All Careers</b-link>
                                </template>
                              </div>
                              <div class="col-2 tags_legend">
                                <div class="tags_legend_icon" id="popoverTarget2_eduLevelTags" style="margin-top: -5px;">
                                  <div class="ic ic8-info5"></div>
                                </div>
                                <b-popover ref="educationLevelTagsLagends" target="popoverTarget2_eduLevelTags" triggers="click" placement="bottom" class="chart_tooltip_popover" container="eduLevelTagsLagends">
                                  <div class="tooltip_row tag_skill tag_edu_level">
                                    <div class="popup_hd row">
                                      <div class="hd_txt col-11">
                                        Legend
                                      </div>
                                      <div class="btn_container col-1">
                                        <button class="btn_close" aria-label="close" @click="closeEducationLevelTagsLegendsPopup">
                                        <span class="ic-close"></span>
                                        </button>
                                      </div>
                                    </div>
                                    <div class="edu_tag_row">
                                      <div class="tag ace_sec_txt edu_H">H</div>
                                      <div class="tag_detail">
                                        High School or Vocational Training
                                      </div>
                                    </div>
                                    <div class="edu_tag_row">
                                      <div class="tag ace_sec_txt edu_C">C</div>
                                      <div class="tag_detail">
                                        Post Secondary Diploma or Certificate
                                      </div>
                                    </div>
                                    <div class="edu_tag_row">
                                      <div class="tag ace_sec_txt edu_A">A</div>
                                      <div class="tag_detail">
                                        Associate's Degree
                                      </div>
                                    </div>
                                    <div class="edu_tag_row">
                                      <div class="tag ace_sec_txt edu_B">B</div>
                                      <div class="tag_detail">
                                        Bachelor's Degree
                                      </div>
                                    </div>
                                    <div class="edu_tag_row">
                                      <div class="tag ace_sec_txt edu_M">M</div>
                                      <div class="tag_detail">
                                        Master's Degree
                                      </div>
                                    </div>
                                    <div class="edu_tag_row">
                                      <div class="tag ace_sec_txt edu_D">D</div>
                                      <div class="tag_detail">
                                        Doctorate's Degree
                                      </div>
                                    </div>
                                  </div>
                                </b-popover>
                                <div id="eduLevelTagsLagends" class="chart_tooltip_popover"></div>
                              </div>
                            </div>
                          </template>
                          <div class="row">
                            <div class="col-12 ace_sec" aria-label="Careers Chart">
                              <div class="avg_val ace_sec_txt" :aria-label="'Median Income $ ' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)">
                                <span class="avg_val_txt">
                                Median Income - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></span>
                                </span>
                              </div>
                              <div class="avg_val_connecter"></div>
                              <div class="bar_chart_container bar_label_inside">
                                <template v-for="(formattedCareer, index) in targetOccupationItems">
                                  <div class="row bar_row ace_sec">
                                    <div class="col-12">
                                      <!--
                                        <div id="careersDetailsToolTip" class="chart_tooltip_popover"></div>
                                        <b-popover :target="'popoverCareersDetails_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="careersDetailsToolTip">
                                          <div class="tooltip_row">
                                             <div class="val">{{ formattedCareer.name }}</div>
                                          </div>
                                          <div class="tooltip_row">
                                            <div class="val"><span v-html="'$' + addCommaInNumber(formattedCareer.medianHourlyEarning)"></span></div>
                                          </div>
                                        </b-popover>
                                        -->
                                      <div class="bar_container jobs" @click="navigateToCareer(formattedCareer)">
                                        <div class="bar_content">
                                          <div class="row">
                                            <div class="col-8 col-lg-8 col-md-8 col-sm-8 bar_label">{{ formattedCareer.Occupation }} </div>
                                            <div class="col-4 col-lg-4 col-md-4 col-sm-4 bar_val"><span v-html="'$' + addCommaInNumber(formattedCareer['Median Earnings'])"></span></div>
                                          </div>
                                          <div class="row edu_label" v-if="(showEducationLevelEnabled && !isWidget) || (isWidget && showEducationLevelOnWidgetEnabled)">
                                            <div class="col-12 tags_row">
                                              <template v-for="edu in formattedCareer['Education'] ">
                                                <div class="tag ace_sec_txt" v-if="edu.score > 0">
                                                  <span class="edu_level" :class="'edu_' + edu.level.charAt(0)" :title="edu.level">
                                                  {{edu.level.charAt(0)}}
                                                  </span>
                                                  <span class="edu_score"><span v-html="formatNumericVal(edu.score)"></span>%</span>
                                                </div>
                                              </template>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="bar" v-bind:style="{width:setIncomeBarWidth(formattedCareer['Median Earnings'])}"></div>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- custom career chart -->
                    </div>
                  </div>
                  <!-- End Careers -->
                </div>
                <!-- .tab_content -->
                <div class="tab_content" id="tabPan_Companies" v-if="(isEMSIFeatureEnabled || isBGTFeatureEnabled) && ((isWidget && unlockCompaniesSkillsOnWidget) || !isWidget)">
                  <!-- Top Companies -->
                  <div class="row pg_sec" v-if="!isShowLess">
                    <div class="col-12 hd ace_sec tree_map" aria-label="Top companies that hire" style="margin-bottom: 0px;">
                      <div class="tree_map_heading">
                        <h2>Top Companies by Number of Job Postings</h2>
                      </div>
                      <div class="tree_map_container" style="margin-top: -4px;">
                        <!--
                          <tree-map-chart :jsonData="companiesTreeMapData"></tree-map-chart>
                          -->
                        <div class="col-12 gph_sec ace_sec" aria-label="Top Companies Posting Chart">
                          <div class="row time_chart_container chart_companies_posting">
                            <!--
                              ToDo - Neeraj [07 Feb 2020]: Limit the result size upto 10 by chart.scss file for now,
                              need to make it configurable under admin settings to update the size of chart
                              -->
                            <template v-for="(topCompaniesItems, index) in topCompaniesItems">
                              <div class="col-12 bar_block ace_sec">
                                <b-popover :target="'popoverTarget_' + index" triggers="hover" placement="top" class="tooltip_popover" container="companiesPostingToolTip">
                                  <div class="tooltip_row">
                                    <div class="hd_txt"><span class="hd_txt" v-html="checkForCompanyName(topCompaniesItems.Company)"></span></div>
                                  </div>
                                  <div class="tooltip_row">
                                    <div class="label"> Postings</div>
                                    <div class="val"><span v-html="formatNumericVal(topCompaniesItems.Total)"></span></div>
                                  </div>
                                  <!--
                                    <div class="tooltip_row">
                                      <div class="val"><span v-html="addCommaInNumber(topCompaniesItems.Unique)"></span></div>
                                      <div class="label">Unique Postings</div>
                                    </div>
                                    -->
                                </b-popover>
                                <div id="companiesPostingToolTip" class="chart_tooltip_popover"></div>
                                <div class="bar_block_inner" :id="'popoverTarget_' + index">
                                  <div class="row">
                                    <div class="col-12 bar_title"><span v-html="checkForCompanyName(topCompaniesItems.Company)"></span></div>
                                    <div class="col-12 bar_val_1">Postings <span v-html="formatNumericVal(topCompaniesItems.Total)"></span></div>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Top Companies -->
                </div>
                <!-- .tab_content -->
                <div class="tab_content" id="tabPan_Skills" v-if="(isEMSIFeatureEnabled || isBGTFeatureEnabled) && ((isWidget && unlockCompaniesSkillsOnWidget) || !isWidget)">
                  <!-- Top Skills -->
                  <div class="row pg_sec" v-if="!isShowLess">
                    <div class="col-12 hd ace_sec tree_map" aria-label="Top skills">
                      <div class="row tree_map_heading skills_tab_heading">
                        <div class="col-10 hd_txt">
                          <h2>Top In-Demand Skills within Job Postings</h2>
                        </div>
                        <div class="col-2 tags_legend">
                          <div class="tags_legend_icon" id="popoverTarget2_skillTags">
                            <div class="ic ic8-info5"></div>
                          </div>
                          <b-popover ref="skillTagsLegendsPopover" target="popoverTarget2_skillTags" triggers="click" placement="bottom" class="chart_tooltip_popover" container="skillsTagsLagends">
                            <div class="tooltip_row tag_skill">
                              <div class="popup_hd row">
                                <div class="hd_txt col-11">
                                  Types of Skills
                                </div>
                                <div class="btn_container col-1">
                                  <button class="btn_close" aria-label="close" @click="closeSkillTagsLegendsPopup">
                                  <span class="ic-close"></span>
                                  </button>
                                </div>
                              </div>
                              <div class="skill_tag_row">
                                <div class="tag ace_sec_txt baselineSkills">F</div>
                                <div class="tag_detail">
                                  <span class="tag_type_title">Foundational Skill:</span>
                                  Important skills that cross industries and occupations, such as organizational skills, communication skills, and project management, etc
                                </div>
                              </div>
                              <!--
                                <span class="skill_tag_row">
                                  <span class="tag ace_sec_txt definingSkills">D</span> Defining Skill
                                </span>
                                <span class="skill_tag_row">
                                  <span class="tag ace_sec_txt necessarySkills">N</span> Necessary Skill
                                </span>
                                -->
                              <div class="skill_tag_row">
                                <div class="tag ace_sec_txt specializedSkills">S</div>
                                <div class="tag_detail">
                                  <span class="tag_type_title">Specialized Skill:</span>
                                  Occupation-specific skills identified in job postings, such as accounting, python programming, informatics, cybersecurity, etc.
                                </div>
                              </div>
                              <div class="skill_tag_row">
                                <div class="tag ace_sec_txt salaryBoostSkills">$</div>
                                <div class="tag_detail">
                                  <span class="tag_type_title">Salary Boost Skill:</span>
                                  High demand skills that may provide a salary boost in an occupation
                                </div>
                              </div>
                              <!--
                                <span class="skill_tag_row">
                                  <span class="tag ace_sec_txt distinguishingSkills" style="width: 38px;">Dis</span> Distinguishing Skill
                                </span>
                                -->
                            </div>
                          </b-popover>
                          <div id="skillsTagsLagends" class="chart_tooltip_popover"></div>
                        </div>
                      </div>
                      <div class="tree_map_container chart_skills" id="careerDetailsSkills" style="margin-top: 20px;">
                        <!--
                          <tree-map-chart :jsonData="skillsTreeMapData"></tree-map-chart>
                          -->
                        <div class="row" v-if="isBGTFeatureEnabled">
                          <template v-if="isSalaryBoostSkill">
                            <div class="col-12 lnk_skill">
                              <div class="lnk_boost_skills">
                                <b-link @click="showSalaryBoostSkills">Show Salary Boost Skills</b-link>
                              </div>
                              <div class="lnk_all_skills">
                                <b-link @click="showAllSkills">Show All Skills</b-link>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div class="col-12 gph_sec ace_sec" aria-label="Top Companies Posting Chart">
                          <div class="row time_chart_container chart_skills">
                            <!--
                              ToDo - Neeraj [07 Feb 2020]: Limit the result size upto 10 by chart.scss file for now,
                              need to make it configurable under admin settings to update the size of chart
                              -->
                            <template v-for="(topSkillsItems, index) in topSkillsItems">
                              <div class="col-12 bar_block ace_sec"
                                :class="'bar_block_' + index + ' ' + topSkillsItems.Types"
                                :aria-label="topSkillsItems.Postings_with_Skill + ' Postings in ' + topSkillsItems.Skill">
                                <b-popover :target="'popoverTarget2_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="skillsToolTip">
                                  <div class="tooltip_row">
                                    <div class="label">Skill</div>
                                    <div class="val">{{topSkillsItems.Skill}}</div>
                                  </div>
                                  <div class="tooltip_row">
                                    <div class="label">Postings</div>
                                    <div class="val"><span v-html="formatNumericVal(topSkillsItems.Postings_with_Skill)"></span></div>
                                  </div>
                                  <div class="tooltip_row tag_skill">
                                    <template v-for="type in topSkillsItems.Types">
                                      <span v-if="type === 'baselineSkills'" class="skill_tag_row">
                                      <span class="tag ace_sec_txt" :class="type">F</span> Foundational Skill
                                      </span>
                                      <!--
                                        <span v-if="type === 'definingSkills'" class="skill_tag_row">
                                          <span class="tag ace_sec_txt" :class="type">D</span> Defining Skill
                                        </span>
                                        <span v-if="type === 'necessarySkills'" class="skill_tag_row">
                                          <span class="tag ace_sec_txt" :class="type">N</span> Necessary Skill
                                        </span>
                                        <span v-if="type === 'distinguishingSkills'" class="skill_tag_row">
                                          <span class="tag ace_sec_txt" :class="type">Dis</span> Distinguishing Skill
                                        </span>
                                        -->
                                      <span v-if="type === 'specializedSkills'" class="skill_tag_row">
                                      <span class="tag ace_sec_txt" :class="type">S</span> Specialized Skill
                                      </span>
                                      <span v-if="type === 'salaryBoostSkills'" class="skill_tag_row">
                                      <span class="tag ace_sec_txt" :class="type">$</span> Salary Boost Skill
                                      </span>
                                    </template>
                                  </div>
                                  <div class="tooltip_row" v-if="isBGTFeatureEnabled && topSkillsItems.Marginal_Value && topSkillsItems.Marginal_Value !== 'null' && topSkillsItems.Marginal_Value && topSkillsItems.Marginal_Value !== null && topSkillsItems.Marginal_Value !== ''">
                                    $<span v-html="addCommaInNumber(topSkillsItems.Marginal_Value)"></span>/Year
                                  </div>
                                </b-popover>
                                <div id="skillsToolTip" class="chart_tooltip_popover"></div>
                                <div class="bar_block_inner" :id="'popoverTarget2_' + index">
                                  <div class="row">
                                    <div class="col-8 bar_title">{{ topSkillsItems.Skill }} </div>
                                    <div class="col-4 bar_val_1 val_postings" style="text-align: right;">
                                      Postings <span v-html="formatNumericVal(topSkillsItems.Postings_with_Skill)"></span>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-6 tag_skill">
                                      <template v-for="type in topSkillsItems.Types">
                                        <span class="tag ace_sec_txt" :class="type" :title="'Foundational Skill'" v-if="type === 'baselineSkills'">F</span>
                                        <!--<span class="tag ace_sec_txt" :class="type" :title="'Defining Skill'" v-if="type === 'definingSkills'">D</span>
                                          <span class="tag ace_sec_txt" :class="type" :title="'Necessary Skill'" v-if="type === 'necessarySkills'">N</span>
                                          <span class="tag ace_sec_txt" :class="type" :title="'Distinguishing Skill'" v-if="type === 'distinguishingSkills'">Dis</span> -->
                                        <span class="tag ace_sec_txt" :class="type" :title="'Specialized Skill'" v-if="type === 'specializedSkills'">S</span>
                                        <span class="tag ace_sec_txt" :class="type" :title="'Salary Boost Skill'" v-if="type === 'salaryBoostSkills'" :id="setSkillRowClass(type)">$</span>
                                      </template>
                                    </div>
                                    <div class="col-6 bar_val_1 val_salary_boost" v-if="isBGTFeatureEnabled && topSkillsItems.Marginal_Value !== 'null' && topSkillsItems.Marginal_Value !== null && topSkillsItems.Marginal_Value && topSkillsItems.Marginal_Value !== ''" style="text-align: right;">
                                      $
                                      <div v-html="addCommaInNumber(topSkillsItems.Marginal_Value)" style="display: inline;"></div>
                                      /Year
                                    </div>
                                  </div>
                                </div>
                                <div class="bar" v-bind:style="{width:setSkillsBarWidth(topSkillsItems.Postings_with_Skill)}"></div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- .tab_content -->
              </div>
              <!-- .tab_content_container -->
            </div>
            <!-- .tab_content_section -->
            <div class="data_source_info" v-if="isBGTFeatureEnabled && !isWidget">Data Source: Burning Glass Technologies.</div>
          </b-card>
        </div>
      </div>

      <div class="unlock_btn_container">
        <b-button v-if="isWidget && !unlockCompaniesSkillsOnWidget && (isBGTFeatureEnabled || isEMSIFeatureEnabled)" size="lg" @click="showNewFormPopup('showAtBottom')" aria-label="verify">
          <span class="ic-lock"></span>
          <span class="btn_txt">click to unlock more details</span>
        </b-button>
      </div>

    </div>
    <!-- pg_sec -->
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF; overflow: hidden;">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>
    <div class="modal_popup_container">
      <b-modal id="userVerificationPopup" ref="newFormModal" centered hide-footer class="usr_verification_popup" no-close-on-backdrop>
        <div slot="modal-header" class="header-section">
          <div class="head_txt">
            Unlock Company and Skills Data
          </div>
          <div class="btn_container">
            <button class="btn_close" aria-label="close" @click="closeModalBox">
            <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-1 lft_col"></div>
          <div class="col-10 content_col" @keydown.enter="login">
            <p v-if="newProspectError" class="text-danger">{{newProspectError}}</p>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="eMail">Email <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="email" v-model.email="newForm.eMail"  placeholder="Email">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="firstName">First Name <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="text" v-model.trim="newForm.firstName" placeholder="First Name">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="lastName">Last Name <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="text" v-model.trim="newForm.lastName" placeholder="Last Name">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section" v-if="showPhoneNumberOnWidgetIsEnabled">
              <div class="col-12">
                <div class="fld-label" id="primaryPhoneNumber">Phone Number</div>
              </div>
              <div class="col-12">
                <b-form-input type="text" v-model.trim="newForm.primaryPhoneNumber" placeholder="Phone Number">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section" v-if="showTermOnWidgetIsEnabled">
              <div class="col-12">
                <div class="fld-label term-fld-label" id="selectedTerm">Terms</div>
              </div>
              <div class="col-12">
                <b-form-select v-model="newForm.selectedTerm" :options="availableTerms" :disabled="(availableTerms.length === 0)"></b-form-select>
              </div>
            </div>
            <div class="row popup_btn_container">
              <div class="col-6 pragya_login_lnk">
                <a :href="loginUrl" target="_blank">I already have a login</a>
              </div>
              <div class="col-6 popup_btn">
                <b-button size="lg" @click="registerProspectiveStudent()" :disabled="!isUnlockEnabled" aria-label="verify">unlock details</b-button>
              </div>
            </div>
          </div>
          <div class="col-1 rgt_col"></div>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal ref="noResultReturnedModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
        <div class="d-block text-center">
          <h5>Career search returned zero results.</h5>
        </div>
        <div class="text-center mt-4">
          <b-button size="sm" @click="closeNoResultModal" style="background: #98002e!important;">Close</b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import BarChart from './BarChart'
  import DoughnutChart from './DoughnutChart'
  import ScatterChart from './ScatterChart'
  import TreeMapChart from './TreeMapChart'
  import _ from 'lodash'

  export default {
    name: 'du-program-guide-career-prospects-detail',
    props: ['cipCode', 'programGuideCode', 'isShowLess', 'isWidget', 'institutionId', 'majorTitle'],
    components: {
      BarChart,
      DoughnutChart,
      ScatterChart,
      TreeMapChart
    },
    data: () => {
      return {
        RECOMMENDATION_TERM_LIMIT: 5,
        selectedState: '',
        selectedMetroArea: '',
        selectedCounty: '',
        careerMinIncome: '',
        careerMaxIncome: '',
        disableSelectState: false,
        disableSelectMetroArea: false,
        disableSelectCounty: false,
        showSkillTagLegends: false,
        isSalaryBoostSkill: false,
        targetOccupationItems: [],
        topCompaniesItems: [],
        topSkillsFields: ['Skill', 'Postings_with_Skill'],
        topSkillsItems: [],
        growthPieOptions: {
          rotation: 1 * Math.PI,
          circumference: 1 * Math.PI,
          tooltips: {
            enabled: false
          }
        },
        newForm: {
          eMail: '',
          firstName: '',
          lastName: '',
          major1: '',
          major1CipCode: '',
          major1Title: '',
          primaryPhoneNumber: '',
          selectedTerm: null
        },
        loginUrl: window.location.origin,
        newProspectError: '',
        isCareerGraphExpanded: false,
        selectedDataInfo: 'US'
      }
    },

    async mounted () {
      this.resetData()
      await this.loadDataForProgramGuideCareerProspects()
    },

    updated () {
      this.$nextTick(() => {
        this.$nextTick(() => {
          // this.callDrawNeedle()
        })
      })
    },

    methods: {
      ...mapActions([
        'loadProgramGuide',
        'loadProgramGuideCareers',
        'loadProgramCareerResult',
        'loadAlumniStreamRecommendations',
        'loadAdvisorStreamRecommendations',
        'resetProgramCareerResult',
        'loadGeoIds',
        'loadRegisterProspectiveStudent',
        'loadLogDashboardActivity',
        'updateShowAllOccupations'
      ]),
      async registerProspectiveStudent () {
        this.newProspectError = ''
        this.newForm.major1 = this.programGuideCode
        this.newForm.major1CipCode = this.cipCode
        this.newForm.major1Title = this.majorTitle
        let institutionId = this.institutionId
        if (this.newForm.eMail.length < 5) {
          this.newProspectError = 'Please enter a valid email.'
        } else if (this.newForm.firstName.length < 1 || this.newForm.lastName.length < 1) {
          this.newProspectError = 'First Name and Last Name are required.'
        } else {
          this.$refs.loadingModal.show()
          this.loadLogDashboardActivity({action: 'submitProspectiveStudentForm', page: 'programCareerProspectsWidget', link: '', programCipCode: this.cipCode, programCode: this.programGuideCode})
          let response = await this.loadRegisterProspectiveStudent({prospectiveStudentForm: this.newForm, learningSpaceId: institutionId})
          if (response && response.data === 'duplicate_email_value') {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Email already exists!'
            })
            this.newProspectError = 'Email already exists. Please click on login.'
            this.newForm = {
              eMail: '',
              firstName: '',
              lastName: '',
              major1: '',
              major1CipCode: '',
              major1Title: '',
              selectedTerm: null
            }
          } else if (response && response.status === 200) {
            let verifyUrl = window.location.origin + '/vue/#/verify?email=' + this.newForm.eMail
            window.open(verifyUrl, '_blank')
            this.$refs.newFormModal.hide()
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Please check your email for instructions!'
            })
            this.newForm = {
              eMail: '',
              firstName: '',
              lastName: '',
              major1: '',
              major1CipCode: '',
              major1Title: '',
              selectedTerm: null
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Error! Please try again!'
            })
          }
          this.$refs.loadingModal.hide()
        }
      },
      toggleShowOccupations () {
        this.updateShowAllOccupations(!this.showAllOccupations)
      },
      getRandomInt (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
      },
      callDrawNeedle () {
        if (!document || !document.getElementById('gauge')) return
        let canvas = document.getElementById('gauge').childNodes[1]
        if (canvas) {
          if (this.formattedCareer && this.formattedCareer.aggregatedGrowthPercentage < -10) {
            this.drawNeedle(canvas, 150, -170 * Math.PI / 180)
          } else if (this.formattedCareer && this.formattedCareer.aggregatedGrowthPercentage >= -10 && this.formattedCareer.aggregatedGrowthPercentage < -5) {
            this.drawNeedle(canvas, 150, -150 * Math.PI / 180)
          } if (this.formattedCareer && this.formattedCareer.aggregatedGrowthPercentage >= -5 && this.formattedCareer.aggregatedGrowthPercentage < 0) {
            this.drawNeedle(canvas, 150, -130 * Math.PI / 180)
          } else if (this.formattedCareer && this.formattedCareer.aggregatedGrowthPercentage >= 0 && this.formattedCareer.aggregatedGrowthPercentage < 5) {
            this.drawNeedle(canvas, 150, -110 * Math.PI / 180)
          } else if (this.formattedCareer && this.formattedCareer.aggregatedGrowthPercentage >= 5 && this.formattedCareer.aggregatedGrowthPercentage < 10) {
            this.drawNeedle(canvas, 150, -90 * Math.PI / 180)
          } else if (this.formattedCareer && this.formattedCareer.aggregatedGrowthPercentage >= 10 && this.formattedCareer.aggregatedGrowthPercentage < 15) {
            this.drawNeedle(canvas, 150, -70 * Math.PI / 180)
          } else if (this.formattedCareer && this.formattedCareer.aggregatedGrowthPercentage >= 15 && this.formattedCareer.aggregatedGrowthPercentage < 20) {
            this.drawNeedle(canvas, 150, -50 * Math.PI / 180)
          } else if (this.formattedCareer && this.formattedCareer.aggregatedGrowthPercentage >= 20 && this.formattedCareer.aggregatedGrowthPercentage < 25) {
            this.drawNeedle(canvas, 150, -30 * Math.PI / 180)
          } else if (this.formattedCareer && this.formattedCareer.aggregatedGrowthPercentage >= 25) {
            this.drawNeedle(canvas, 150, -10 * Math.PI / 180)
          }
        }
      },
      drawNeedle (canvas, radius, radianAngle) {
        var ctx = canvas.getContext('2d')
        var cw = canvas.offsetWidth
        var ch = canvas.offsetHeight
        var cx = cw / 2
        var cy = ch - (ch / 4)

        ctx.translate(cx, cy)
        ctx.rotate(radianAngle)
        ctx.beginPath()
        ctx.moveTo(0, -5)
        ctx.lineTo(radius, 0)
        ctx.lineTo(0, 5)
        ctx.fillStyle = 'rgba(100, 100, 100, 1)'
        ctx.fill()
        ctx.rotate(-radianAngle)
        ctx.translate(-cx, -cy)
        ctx.beginPath()
        ctx.arc(cx, cy, 7, 0, Math.PI * 2)
        ctx.fill()
      },
      async loadDataForProgramGuideCareerProspects () {
        // load related career information, if any exists
        if (this.isWidget) {
          await this.loadProgramGuideCareers({ cipCode: this.cipCode, code: this.programGuideCode, showAllOccupations: this.showAllOccupations })
          await this.loadGeoIds()
        }
      },
      getLocationParamForCareerSearch () {
        let locationParam = ''
        let selectedState = (this.selectedState && this.selectedState.label) ? this.selectedState.label : ''
        let selectedMetroArea = (this.selectedMetroArea && this.selectedMetroArea.label) ? this.selectedMetroArea.label : ''
        let selectedCounty = (this.selectedCounty && this.selectedCounty.label) ? this.selectedCounty.label : ''

        if (selectedState) {
          locationParam = 'state:' + this.labelsToCodesMap.stateGeoIds[selectedState]
        } else if (selectedMetroArea) {
          locationParam = 'msa:' + this.labelsToCodesMap.msaGeoIds[selectedMetroArea]
        } else if (selectedCounty) {
          locationParam = 'county:' + this.labelsToCodesMap.countyGeoIds[selectedCounty]
        }
        return locationParam
      },
      showFloatingFilterSection () {
        $('.fix_pg_tabs .filters_section').css('display', 'block')
      },
      hideFloatingFilterSection () {
        $('.fix_pg_tabs .filters_section').css('display', 'none')
      },
      showSalaryBoostSkills () {
        $('#careerDetailsSkills').addClass('show_boost_skills_only')
      },
      showAllSkills () {
        $('#careerDetailsSkills').removeClass('show_boost_skills_only')
      },
      closeNoResultModal () {
        this.selectedState = ''
        this.selectedMetroArea = ''
        this.$refs.noResultReturnedModal.hide()
      },
      careerSearchClicked () {
        let cipCode = this.formattedCareer.cipCode
        let programCode = this.formattedCareer.code
        let locationParam = this.getLocationParamForCareerSearch()

        if (!locationParam || !cipCode) {
          return
        }

        this.$refs.loadingModal.show()
        this.loadProgramCareerResult({cipCode: cipCode, programCode: programCode, locationParam: locationParam}).then(response => {
          this.$refs.loadingModal.hide()
          if (!response) {
            this.$notify({
              group: 'notify',
              type: 'warning',
              title: '',
              text: 'Career search returned zero results.'
            })
            if (this.isWidget) {
              this.$refs.noResultReturnedModal.show()
            }
          }
          if (this.selectedCounty) {
            this.selectedDataInfo = this.selectedCounty.label
          } else if (this.selectedState) {
            this.selectedDataInfo = this.selectedState.label
          } else if (this.selectedMetroArea) {
            this.selectedDataInfo = this.selectedMetroArea.label
          } else {
            this.selectedDataInfo = 'US'
          }
          this.$forceUpdate()
        })
        this.loadLogDashboardActivity({action: 'filterByCityOrState', page: 'programCareerProspects', link: '', programCipCode: this.cipCode, programCode: this.programGuideCode})
      },
      checkForCompanyName (companyName) {
        if (companyName === '[Unknown]') {
          return 'Others'
        }
        return companyName
      },
      addCommaInNumber (numValue) {
        if (numValue && numValue.length > 0) {
          let numericValue = Math.floor(numValue)
          return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
        return numValue
      },
      setSkillRowClass (skillType) {
        if (skillType === 'salaryBoostSkills') {
          this.isSalaryBoostSkill = true
        } else {
          this.isSalaryBoostSkill = false
        }
      },
      formatNumericVal (numValue) {
        let numericValue = Math.floor(numValue)
        return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      setIncomeBarWidth (numValue) {
        return ((numValue / (this.formattedCareer.aggregatedMedianHourlyEarning * 2)) * 100) + '%'
      },
      setSkillsBarWidth (postings) {
        return ((postings / (this.formattedCareer.aggregatedLastYearJob)) * 100) + '%'
      },
      formatOptionsForVSelect (map) {
        let formatted = []
        Object.keys(map).sort().forEach((key, i) => {
          formatted.push({id: key, label: map[key]})
        })
        formatted.sort((a, b) => (a.label >= b.label) ? 1 : -1)
        return formatted
      },
      setDotMargin (positionValue) {
        let getContainerWidth = $('.custom_dot_gph_container').width()
        let getXPosition = (positionValue - 20000) / (getContainerWidth / 2)
        return getXPosition + 'px'
      },
      setMinIncome () {
        let formatted = []
        this.formattedCareers.forEach((career) => {
          formatted.push(career.medianHourlyEarning)
        })
        let minIncome = Math.min.apply(Math, formatted)
        let maxIncome = Math.max.apply(Math, formatted)
        let incomeDiff = 3000
        this.careerMinIncome = Math.round((minIncome - incomeDiff) / 1000) * 1000
        this.careerMaxIncome = Math.ceil((maxIncome + incomeDiff) / 1000) * 1000
        return (Math.round((minIncome - incomeDiff) / 1000) * 1000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      resetData () {
        // this ensures the original program guide object info binds to the ui
        this.targetOccupationItems = []
        this.topCompaniesItems = []
        this.topSkillsItems = []
        this.resetProgramCareerResult()
        if (!this.disableSelectState && !this.disableSelectMetroArea) {
          this.selectedDataInfo = 'US'
        }
      },
      getCoursePlanningPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getCoursePlanningPackage(packages)
      },
      hasLaborData (career) {
        if (!career) {
          return false
        }
        return career.targetOccupations || career.topPostingCompanies || career.topSkills
      },
      showNewFormPopup (popupPosition) {
        this.loadLogDashboardActivity({action: 'unlockCompaniesSkills', page: 'programCareerProspectsWidget', link: '', programCipCode: this.cipCode, programCode: this.programGuideCode})
        this.$refs.newFormModal.show()
        $('.usr_verification_popup').removeClass('showAtTop')
        $('.usr_verification_popup').removeClass('showAtBottom')
        $('.usr_verification_popup').addClass(popupPosition)
      },
      showTabContent (tabId, tabPanelId) {
        this.loadLogDashboardActivity({action: 'companiesOrSkillsTabClicked', page: 'programCareerProspects', link: '', programCipCode: this.cipCode, programCode: this.programGuideCode})
        $('.tab_content').removeClass('active')
        $('#' + tabPanelId).addClass('active')
        $('.tabs .nav-link').removeClass('active')
        $('#' + tabId).addClass('active')
      },
      closeModalBox () {
        this.$root.$emit('bv::hide::modal', 'userVerificationPopup')
        this.$parent.isShowTagPopup = false
        this.newForm = {
          eMail: '',
          firstName: '',
          lastName: '',
          major1: '',
          major1CipCode: '',
          major1Title: '',
          selectedTerm: null
        }
      },
      closeSkillTagsLegendsPopup () {
        this.$refs.skillTagsLegendsPopover.$emit('close')
      },
      closeEducationLevelTagsLegendsPopup () {
        this.$refs.educationLevelTagsLagends.$emit('close')
      },
      navigateToCareer (career) {
       if (!this.isWidget) {
          console.log(career)
          if (!career.code) {
            this.$notify({
              group: 'notify',
              type: 'warning',
              title: '',
              text: 'Career does not exist.'
            })
          } else {
            let routerParams = {
              code: career.pragyaSoc,
              cipCode: this.cipCode,
              programCode: this.programGuideCode,
              returnTo: 'programGuideCareers',
              showBackToResultButton: false
            }
            return this.$router.push({ name: 'careerDetail', params: routerParams, query: {returnTo: 'programGuideCareers'} })
          }
        }
      },
    },
    computed: {
      ...mapState({
        'programGuide': state => state.programguide.programGuideObject,
        'showAllOccupations': state => state.programguide.showAllOccupations,
        'careersObject': state => state.programguide.careers,
        'careerResult': state => state.programguide.careerResult,
        'packages': state => state.institution.packages,
        'geoIdMap': state => state.career.geoIdMap,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'termMapWithCutOffDate': state => state.institution.termMapWithCutOffDate
      }),
      isUnlockEnabled () {
        return ((this.newForm.eMail.length > 0) && (this.newForm.firstName.length > 0) && (this.newForm.lastName.length > 0))
      },
      availableTerms () {
        let terms = []
        let entries = Object.entries(this.termMapWithCutOffDate)
        if (entries && entries.length > 0) {
          terms.push({value: null, text: 'Select a Term'})
          for (const [key, data] of entries) {
            if (key) {
              terms.push({value: key, text: data.label})
            }
          }
          return terms
        }
        return []
      },
      showTermOnWidgetIsEnabled () {
        let termFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_TERM_ON_WIDGET]
        return termFeature && termFeature.enabled
      },
      showPhoneNumberOnWidgetIsEnabled () {
        let phoneNumberFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_WIDGET]
        return phoneNumberFeature && phoneNumberFeature.enabled
      },
      showEducationLevelOnWidgetEnabled () {
        let educationLevelOnWidgetFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_EDUCATION_LEVEL_ON_WIDGET]
        return educationLevelOnWidgetFeature && educationLevelOnWidgetFeature.enabled
      },
      showEducationLevelEnabled () {
        let educationLevelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_EDUCATION_LEVEL]
        return educationLevelFeature && educationLevelFeature.enabled
      },
      isEMSIFeatureEnabled () {
        let emsiFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_EMSI_SOURCE]
        return emsiFeature && emsiFeature.enabled
      },
      isBGTFeatureEnabled () {
        let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
        return bgtFeature && bgtFeature.enabled
      },
      showCityStateFilterOnWidget () {
        let showCityStateFilterOnWidgetFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_CITY_STATE_FILTER_ON_WIDGET]
        return showCityStateFilterOnWidgetFeature && showCityStateFilterOnWidgetFeature.enabled
      },
      unlockCompaniesSkillsOnWidget () {
        let unlockCompaniesSkillsOnWidgetFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.UNLOCK_COMPANIES_SKILLS_ON_WIDGET]
        return unlockCompaniesSkillsOnWidgetFeature && unlockCompaniesSkillsOnWidgetFeature.enabled
      },
      companiesTreeMapData () {
        if (this.formattedCareer && this.formattedCareer.topPostingCompanies) {
          let jsonData = {
            name: ' ',
            children: []
          }
          /*
          this.formattedCareer.topPostingCompanies.forEach((career) => {
            let parsedCareer = JSON.parse(career)
            let careerObj = {
              name: parsedCareer.name,
              value: parsedCareer.unique_postings
            }
            jsonData.children.push(careerObj)
          })
          */
          let length = this.formattedCareer.topPostingCompanies.length
          let count = (length < 4) ? length : 4
          for (var i = 0; i < count; i++) {
            let parsedCareer = JSON.parse(this.formattedCareer.topPostingCompanies[i])
            let name = parsedCareer.name
            let value = parsedCareer.unique_postings
            if (parsedCareer.name === '[Unknown]') {
              name = 'Others'
            }
            if (parsedCareer.name === 'ACCENTURE, INC.') {
              name = 'Accenture'
            }
            if (parsedCareer.name === 'Robert Half International Inc.') {
              name = 'Robert Half'
            }
            let careerObj = {
              name: name,
              value: value
            }
            jsonData.children.push(careerObj)
          }
          return jsonData
        }
        return {}
      },
      skillsTreeMapData () {
        if (this.formattedCareer && this.formattedCareer.topSkills) {
          let jsonData = {
            name: 'Top Skills',
            children: []
          }
          /*
          this.formattedCareer.topSkills.forEach((career) => {
            let parsedCareer = JSON.parse(career)
            let careerObj = {
              name: parsedCareer.name,
              value: parsedCareer.unique_postings
            }
            jsonData.children.push(careerObj)
          })
          */
          let length = this.formattedCareer.topSkills.length
          let count = (length < 4) ? length : 4
          for (var i = 0; i < count; i++) {
            let parsedCareer = JSON.parse(this.formattedCareer.topSkills[i])
            let name = parsedCareer.name
            if (name === 'JavaScript (Programming Language)') {
              name = 'JavaScript'
            }
            if (name === 'Java (Programming Language)') {
              name = 'Java'
            }
            if (name === 'Agile Software Development') {
              name = 'Agile'
            }
            let careerObj = {
              name: name,
              value: parsedCareer.unique_postings
            }
            jsonData.children.push(careerObj)
          }
          return jsonData
        }
        return {}
      },
      incomeScatterData () {
        if (this.formattedCareers) {
          let data = {
            labels: [],
            datasets: [
              {
                label: '',
                fill: false,
                borderWidth: 0,
                borderColor: 'rgb(245, 245, 245)',
                backgroundColor: 'rgb(245, 245, 245)',
                pointRadius: 14,
                pointHoverRadius: 16,
                pointBackgroundColor: '#157099',
                pointBorderWidth: 2,
                pointBorderColor: '#014966',
                data: []
              }
            ]
          }
          this.formattedCareers.forEach((career) => {
            let dataPoint = {
              x: career.medianHourlyEarning,
              y: this.getRandomInt(0, 1)
            }
            data.datasets[0].data.push(dataPoint)
            data.labels.push(career.name)
          })
          return data
        }
        return {}
      },
      jobPostingsPieData () {
        let data = {
          // labels: ['Job Postings'],
          datasets: [
            {
              label: 'Job Postings',
              backgroundColor: '#8db350',
              data: []
            }
          ]
        }
        if (this.formattedCareer && this.formattedCareer.aggregatedLastYearJob) {
          data.datasets[0].data.push(this.formattedCareer.aggregatedLastYearJob)
        }
        return data
      },
      growthPieData () {
        let data = {
          // labels: ['Less than 0%', '0-15%', 'Greater than 15%'],
          datasets: [
            {
              labels: 'Growth',
              backgroundColor: ['#f5b518', '#9fc958', '#0a7714'],
              data: [15, 15, 15]
            }
          ]
        }
        if (this.formattedCareer && this.formattedCareer.aggregatedGrowthPercentage) {
          return data
        }
        return {}
      },
      medianIncomePieData () {
        let data = {
          // labels: ['Median Income'],
          datasets: [
            {
              label: 'Median Income',
              backgroundColor: '#8db350',
              data: []
            }
          ]
        }
        if (this.formattedCareer && this.formattedCareer.aggregatedMedianHourlyEarning) {
          data.datasets[0].data.push(this.formattedCareer.aggregatedMedianHourlyEarning)
        }
        return data
      },
      formattedCareers () {
        console.log('got here', this.careersObject)
        let formattedCareers = []
        let careers = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
        if (!this.hasLaborData(careers)) {
          return []
        }
        // this.resetData()
        careers.targetOccupations.forEach((career) => {
          formattedCareers.push(JSON.parse(career))
        })
        formattedCareers = formattedCareers.sort((a, b) => (parseFloat(a.medianHourlyEarning) <= parseFloat(b.medianHourlyEarning)) ? 1 : -1)
        return formattedCareers
      },
      formattedCareer () {
        let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
        if (!this.hasLaborData(formattedCareer)) {
          return {}
        }
        this.resetData()
        formattedCareer.targetOccupations.forEach((career, i) => {
          let curr = JSON.parse(career)
          if (i === 0) {
            formattedCareer.timeframe = curr.timeframe
            formattedCareer.endYear = curr.year
            formattedCareer.startYear = formattedCareer.endYear - 10
            formattedCareer.tenYearOldJobTitle = curr.tenYearOldJobTitle
          }
          let tenYearOldJobTitle = formattedCareer.tenYearOldJobTitle
          let growthTitle = 'Growth (' + formattedCareer.timeframe + ')'
          let currItem = {
            'Occupation': curr.name,
            'Annual Openings': curr.annualOpening,
            'Median Earnings': curr.medianHourlyEarning,
            'Education': curr.education,
            'code': curr.code,
            'pragyaSoc': curr.pragyaSoc
          }
          currItem[tenYearOldJobTitle] = curr.tenYearOldJob
          currItem[growthTitle] = curr.growth
          // if (parseFloat(curr.growth) > 10) {
          this.targetOccupationItems.push(currItem)
          // }
        })
        this.targetOccupationItems = this.targetOccupationItems.sort((a, b) => (parseFloat(a['Median Earnings']) <= parseFloat(b['Median Earnings'])) ? 1 : -1)

        if (!formattedCareer.topPostingCompanies) {
          return formattedCareer
        }

        formattedCareer.topPostingCompanies.forEach((company, i) => {
          let curr = JSON.parse(company)
          let tenYearPostingTitle = 'Total/Unique (' + formattedCareer.timeframe + ')'
          let currItem = {'Company': curr.name}
          currItem[tenYearPostingTitle] = curr.total_postings + ' / ' + curr.unique_postings
          currItem['Total'] = curr.total_postings
          currItem['Unique'] = curr.unique_postings
          currItem['Posting Intensity'] = (Math.round(curr.posting_intensity)) + ':1'
          this.topCompaniesItems.push(currItem)
        })
        this.topCompaniesItems = this.topCompaniesItems.sort((a, b) => (Number(a.Total) <= Number(b.Total)) ? 1 : -1)
        if (!formattedCareer.topSkills) {
          return formattedCareer
        }

        formattedCareer.topSkills.forEach((skill, i) => {
          let curr = JSON.parse(skill)
          let currItem = {'Skill': curr.name,
            'Postings_with_Skill': curr.unique_postings,
            'Types': curr.types,
            'Marginal_Value': curr.marginal_value }
          this.topSkillsItems.push(currItem)
        })
        this.topSkillsItems = this.topSkillsItems.sort((a, b) => (Number(a.Postings_with_Skill) <= Number(b.Postings_with_Skill)) ? 1 : -1)
        return formattedCareer
      },
      formattedGeoIdMap () {
        let formattedMap = {}
        let map = this.geoIdMap

        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = this.formatOptionsForVSelect(map.stateGeoIds)
          formattedMap.msaGeoIds = this.formatOptionsForVSelect(map.msaGeoIds)
          formattedMap.countyGeoIds = this.formatOptionsForVSelect(map.countyGeoIds)
        }
        return formattedMap
      },
      labelsToCodesMap () {
        let map = this.geoIdMap
        let formattedMap = {}
        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = _.invert(map.stateGeoIds)
          formattedMap.msaGeoIds = _.invert(map.msaGeoIds)
          formattedMap.countyGeoIds = _.invert(map.countyGeoIds)
        }
        return formattedMap
      },
      targetOccupationFields () {
        let fields = ['Occupation']
        if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
          let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
          fields.push((curr.tenYearOldJobTitle))
          fields.push('Annual Openings')
          fields.push('Median Earnings')
          fields.push('Growth (' + curr.timeframe + ')')
          return fields
        } else {
          return []
        }
      },
      topCompaniesFields () {
        let fields = ['Company']
        if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
          let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
          fields.push('Total/Unique (' + curr.timeframe + ')')
          fields.push('Posting Intensity')
          return fields
        } else {
          return []
        }
      }
    },
    watch: {
      selectedState (newState) {
        if (!newState) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
          this.resetData()
          this.loadDataForProgramGuideCareerProspects()
          this.isSalaryBoostSkill = false
        } else {
          this.disableSelectState = false
          this.disableSelectMetroArea = true
          this.disableSelectCounty = true
        }
      },
      selectedMetroArea (newMSA) {
        if (!newMSA) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
          this.resetData()
          this.loadDataForProgramGuideCareerProspects()
          this.isSalaryBoostSkill = false
        } else {
          this.disableSelectState = true
          this.disableSelectMetroArea = false
          this.disableSelectCounty = true
        }
      },
      selectedCounty (newCounty) {
        if (!newCounty) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
        } else {
          this.disableSelectState = true
          this.disableSelectMetroArea = true
          this.disableSelectCounty = false
        }
      }
    }
  }
</script>
<style scoped>
  .frm_btn_col .btn {
    margin-top: 32px;
    height: 40px;
  }
  .state .v-select .dropdown-toggle {
    background-color: #d0eaf4;
  }
  .city .v-select .dropdown-toggle {
    background-color: #ffebed;
  }
  .term-fld-label {
    text-align: left;
    margin-bottom: .5rem;
    font-size: 1.15rem;
    color: #323232;
    padding-left: .3rem;
  }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/DuProgramGuideCareerProspectsDetail.vue